// extracted by mini-css-extract-plugin
export default {"addClassButton":"style_addClassButton__Pb1Yt"};